import { SessionActions } from "../actions/session.action";

export interface SessionState {
  consentVisible: boolean;
  hardCapExpired: boolean;
}

interface SessionAction {
  type: string;
}

const defaultState: SessionState = {
  consentVisible: false,
  hardCapExpired: false,
};

export default function SessionStateReducer(
  state = defaultState,
  action: SessionAction,
): SessionState {
  switch (action.type) {
    case SessionActions.SESSION_EXPIRED_CONSENT:
      return {
        ...state,
        consentVisible: true,
      };
    case SessionActions.SESSION_HARD_CAP_EXPIRED:
      return {
        ...state,
        consentVisible: false,
        hardCapExpired: true,
      };
    case SessionActions.CLEAR_SESSION_EXPIRY:
      return {
        ...state,
        consentVisible: false,
      };
    default:
      return state;
  }
}
